import {Link} from 'react-router-dom'

export const UserRequest = () => {
  return (
    <div className='centered-section'>
      <div className='message-box w-container'>
        <h2 className='h2-titles center'>Your user request has been sent successfully</h2>
        <p className='paragraph justified'>
          Your request is being processed, it will be reviewed personally by one of our
          administrators, we will notify you by email when your request is approved, until then you
          still do not have a password to enter the site, this can be set when your request is
          approved
        </p>
        <Link to='/'>
          <span className='button center w-button'>Accept</span>
        </Link>
      </div>
    </div>
  )
}
